import { ClientRegisterForm } from "../types/forms/client-register-form";
import { RegisterWithCompanyForm } from "../types/forms/register-with-company-form";
import { UserForm } from "../types/forms/user-form";
import { Me } from "../types/models/me";
import { HttpClient } from "./http-client";

export class UserService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  /**
   * `null` bascule le compte en mode privé : les courses réservées ensuite ne
   * relèvent d'aucune entreprise. La désélection a son propre verbe, une route
   * `PATCH .../{id}` ne pouvant pas porter d'identifiant absent.
   */
  async switchActiveEntreprise(idEntreprise: number | null): Promise<void> {
    if (idEntreprise === null) {
      await this.http.delete("/api/utilisateurs/me/entreprise-active");
      return;
    }

    await this.http.patch(
      `/api/utilisateurs/me/entreprise-active/${idEntreprise}`,
    );
  }

  async me(): Promise<Me> {
    return this.http.get<Me>("/api/account/me");
  }

  async updateUser(userId: number, userData: UserForm): Promise<void> {
    await this.http.put(`/api/users/${userId}`, userData);
  }

  async updateMyLanguage(langue: number): Promise<void> {
    await this.http.put("/api/users/me/langue", { langue });
  }

  async register(
    userData: Omit<ClientRegisterForm, "confirmPassword">,
  ): Promise<void> {
    await this.http.post("/api/account/register/client", userData);
  }

  async registerAsDriverManager(
    userData: Omit<RegisterWithCompanyForm, "confirmPassword">,
  ): Promise<void> {
    await this.http.post("/api/account/register/drivermanager", userData);
  }
}
